var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconStaffBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon_staff_blue"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_staff_blue",
    clipPath: "url(#clip-icon_staff_blue)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(-143.615 -290.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    d: "M3.55-.5A4.05,4.05,0,1,1-.5,3.55,4.055,4.055,0,0,1,3.55-.5Zm0,7.1A3.05,3.05,0,1,0,.5,3.55,3.054,3.054,0,0,0,3.55,6.6Z",
    transform: "translate(152.064 292.54)",
    fill: "#377EF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M161.367,312.617a.5.5,0,0,1-.5-.5v-7.9a2.209,2.209,0,0,0-2.207-2.206h-6.091a2.208,2.208,0,0,0-2.206,2.206v7.9a.5.5,0,0,1-1,0v-7.9a3.21,3.21,0,0,1,3.206-3.206h6.091a3.21,3.21,0,0,1,3.207,3.206v7.9A.5.5,0,0,1,161.367,312.617Z",
    fill: "#377EF3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    d: "M0,7.838a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V7.338A.5.5,0,0,1,0,7.838Z",
    transform: "translate(152.531 304.78)",
    fill: "#377EF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_4",
    "data-name": "Line 4",
    d: "M0,7.838a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V7.338A.5.5,0,0,1,0,7.838Z",
    transform: "translate(158.699 304.78)",
    fill: "#377EF3"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStaffBlue);
export default __webpack_public_path__ + "static/media/icon_staff_blue.c6ffa481c3870d32b6346b58e8dccf56.svg";
export { ForwardRef as ReactComponent };